module.exports = __webpack_public_path__ + "static/media/Brendan-Wovchko.13f42bc2.jpg";